import React from 'react';

const LoaderMaskSlider = () => {
    return (
        <div className="loader-mask-slider">
            <div className="loader-mask-item">
                {/* <img src="/images/loader.gif" alt="" className="img-fluid" /> */}
            </div>
        </div>
    );
};

export default LoaderMaskSlider;